"use strict";
var DateParts = (function () {
    function DateParts(fullDate, dateString, timeString) {
        this.fullDateTime = fullDate;
        this.dateString = dateString;
        this.timeString = timeString;
    }
    return DateParts;
}());
exports.DateParts = DateParts;
//# sourceMappingURL=D:/a/1/s/base/src/models/date-models/api-date-parts.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/date-models/api-date-parts.model.js